import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import React from 'react';
import { useDonationReceiptPreviewQuery } from '../../../../../queries';
import { LoadingSpinner } from '../../../../components/LoadingSpinner';
import { IModalProps, Modal } from '../../../../components/Modal';
import { styleSheet } from '../styles';

interface IProps {
	modalProps: IModalProps;
	surveyId?: string;
	confirmationMessage?: Api.IRawRichTextContentState;
	impersonationContext?: Api.IImpersonationContext;
}

// srcDoc rather than contentDocument.write: an effect keyed on the query data never re-fires
// when react-query returns cached data on reopen, leaving the fresh iframe blank.
export const DonationReceiptPreviewModal: React.FC<IProps> = ({
	modalProps,
	surveyId,
	confirmationMessage,
	impersonationContext,
}) => {
	const previewQuery = useDonationReceiptPreviewQuery({
		surveyId,
		confirmationMessage,
		enabled: modalProps.isOpen,
		impersonationContext,
	});

	return (
		<Modal
			{...modalProps}
			className={css(styleSheet.receiptPreviewModal)}
			shouldCloseOnOverlayClick={true}
			useDefaultHeader={true}
			headerText='Receipt Preview'
		>
			{previewQuery.data?.html ? (
				<iframe
					title='Donation receipt preview'
					className={css(styleSheet.receiptPreviewIframe)}
					sandbox=''
					srcDoc={`<html><head><meta charset="utf-8"/></head><body style="padding:0;margin:0;">${previewQuery.data.html}</body></html>`}
				/>
			) : (
				<LoadingSpinner type='large' className='absolute-center' />
			)}
		</Modal>
	);
};
